// Moved to PDStreakBank Component

import React, { useState } from "react";
import PDContest from "./PDContest";
import PDContestWinners from "./PDContestWinners";
import PDContestLeaders from "./PDContestLeaders";

const TABS = [
  "leaderboard",
  "winners",
  "contest",
];

const TAB_ICONS = {
  leaderboard: "🏆",
  rewards: "🎁",
  contest: "🚀",
};

const PDLeaderboard = ({ currentTheme, t }) => {
  const [activeTab, setActiveTab] = useState("streaks");

  const cardClass = `
    ${currentTheme.card}
    ${currentTheme.text}
    border
    ${currentTheme.border}
    rounded-2xl
    p-5
  `;

  return (
    <div className="space-y-6 bg-gray-900 p-6 rounded-xl text-white border-t-2 border-cyan-200 mt-2">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-2">
        {TABS.map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`
              p-2
              rounded-lg
              text-xs
              border
              transition-all
              ${
                activeTab === tab
                  ? "bg-blue-600 text-white border-blue-600"
                  : "bg-gray-200 text-gray-700 border-gray-300 hover:bg-gray-300"
              }
            `}
          >
            {TAB_ICONS[tab]} {t(tab)}
          </button>
        ))}
      </div>

      {activeTab === "leaderboard" && (
        <PDContestLeaders />
      )}

      {activeTab === "winners" && (
        <PDContestWinners />
      )}

      {activeTab === "contest" && (
        <PDContest />
      )}
    </div>
  );
};

export default PDLeaderboard;